const messages = {
    header: 'Transactions',
};

export default messages;
